import intl from 'react-intl-universal';
import { Button } from '@mui/material';
import SingleChip from './components/DiagnosticResult/ResultChip';
import PropTypes from 'prop-types';

export const sourceOrganizationColumn = () => {
  return {
    header: intl.get('kenshin_case_table_header_source_organization'),
    accessorKey: 'srcOrgName',
    size: 50,
    enableColumnActions: false,
    enableColumnFilter: true,
  };
};

export const caseIdColumn = () => {
  return {
    header: intl.get('kenshin_case_table_header_case_id'),
    accessorKey: 'caseIdentifierId',
    size: 50,
    enableColumnActions: false,
    enableColumnFilter: true,
  };
};

export const patientIdColumn = () => {
  return {
    header: intl.get('kenshin_case_table_header_patient_id'),
    accessorKey: 'patientId',
    size: 50,
    enableColumnActions: false,
    enableColumnFilter: true,
  };
};

export const studyInstanceUidColumn = () => {
  return {
    header: intl.get('kenshin_case_table_header_study_instance_uid'),
    accessorKey: 'studyInstanceUID',
    size: 50,
    enableColumnActions: false,
    enableColumnFilter: true,
  };
};

export const bodyPartColumn = () => {
  return {
    header: intl.get('kenshin_case_table_header_body_part'),
    accessorKey: 'bodypart',
    size: 50,
    enableColumnActions: false,
    enableColumnFilter: true,
  };
};

export const modalityColumn = () => {
  return {
    header: intl.get('kenshin_case_table_header_modality'),
    accessorKey: 'modality',
    size: 50,
    enableColumnActions: false,
    enableColumnFilter: true,
  };
};

export const diagnosticResultColumn = () => {
  return {
    header: intl.get('kenshin_case_table_header_diagnostic_result'),
    accessorKey: 'diagnosis',
    size: 50,
    enableColumnActions: false,
    enableColumnFilter: true,
    filterVariant: 'select',
    filterSelectOptions: [
      {
        label: intl.get('kenshin_case_diagnostic_result_to_be_diagnosed'),
        value: 'TO_BE_DIAGNOSED',
      },
      {
        label: intl.get('kenshin_case_diagnostic_result_diagnosed_healthy'),
        value: 'DIAGNOSED_HEALTHY',
      },
      {
        label: intl.get('kenshin_case_diagnostic_result_diagnosed_sick'),
        value: 'DIAGNOSED_SICK',
      },
      {
        label: intl.get('kenshin_case_diagnostic_result_diagnosed_unknown'),
        value: 'DIAGNOSED_UNKNOWN',
      },
    ],
    filterFn: (row, id, filterValue) => {
      return row.getValue(id) === filterValue;
    },
    Cell: ({ renderedCellValue }) =>
      diagnosticResultCell({ renderedCellValue }),
  };
};

const diagnosticResultCell = ({ renderedCellValue }) => {
  return <SingleChip result={renderedCellValue} />;
};

diagnosticResultCell.propTypes = {
  renderedCellValue: PropTypes.string.isRequired,
};

export const viewerColumn = ({ handleOpenViewer }) => {
  return {
    header: intl.get('kenshin_case_table_header_viewer'),
    accessorKey: 'viewerInfo',
    size: 50,
    enableSorting: false,
    enableColumnActions: false,
    enableColumnFilter: false,
    Cell: ({ renderedCellValue }) =>
      viewerCell({ renderedCellValue, handleOpenViewer }),
  };
};

const viewerCell = ({ renderedCellValue, handleOpenViewer }) => {
  const caseId = renderedCellValue.caseId;
  return (
    <Button
      variant="contained"
      color="primary"
      style={{ color: 'white' }}
      onClick={() => {
        handleOpenViewer(caseId);
      }}>
      {intl.get('case_list_button_view')}
    </Button>
  );
};
viewerCell.propTypes = {
  renderedCellValue: PropTypes.shape({
    caseId: PropTypes.string.isRequired,
  }).isRequired,
  handleOpenViewer: PropTypes.func.isRequired,
};
